module.exports = __webpack_public_path__ + "static/media/esrcolor.14a35ece.png";